import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import DDIOptions from 'src/app/data/ddi';
import { ApiService } from 'src/app/services/api/api.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import Swal from 'sweetalert2';
import fakerbr from 'faker-br';
import { MaskPipe } from 'ngx-mask';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-settings-zeroing-funds',
  templateUrl: './dashboard-settings-zeroing-funds.component.html',
  styleUrls: ['./dashboard-settings-zeroing-funds.component.scss'],
})
export class DashboardSettingsZeroingFundsComponent implements OnInit {
  fundForm = this.formBuilder.group({
    document: [null, [Validators.required]],
    corporate_name: [null, [Validators.required]],
    manager_name: [null, [Validators.required]],
    manager_email: [null, [Validators.required]],
    manager_ddi: [null, [Validators.required]],
    manager_phone: [null, [Validators.required]],
  });

  DDIOptions = DDIOptions;

  funds: any[] = [];
  fund: any = undefined;

  visible_funds: any[] = [];
  addFund = false;

  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private toast: ToastService,
    private signupService: SignupService,
    private maskPipe: MaskPipe,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setData();
    this.getData();
  }

  redirect(url: string) {
    this.router.navigate([url]);
  }

  addFundToggle(status: boolean) {
    this.addFund = status;
  }

  closeModal() {
    this.fundForm.reset();
    this.addFund = false;
    this.fund = undefined;
  }

  getDisabled() {
    return this.fundForm.invalid;
  }

  setFund(fund: any) {
    this.fundForm.patchValue({
      ...fund,
      manager_ddi: '55',
    });

    this.fund = fund;
    this.addFundToggle(true);
  }

  async getData() {
    this.loading = true;

    try {
      const res = await this.api.get({
        route: 'api/registration/zeroing_fund/',
        token: true,
      });

      this.funds = res;
      this.visible_funds = [...this.funds].splice(0, 10);
    } catch (error) {
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.loading = false;
  }

  async addZeroingFund() {
    try {
      const values = this.fundForm.value;

      const res = this.fund
        ? await this.api.patch({
            route: `api/registration/zeroing_fund/${this.fund.id}/`,
            token: true,
            body: values,
          })
        : await this.api.post({
            route: 'api/registration/zeroing_fund/',
            token: true,
            body: values,
          });

      this.getData();

      this.toast.show(
        'info',
        `Fundo ${this.fund ? 'atualizado' : 'adicionado'} com sucesso`,
        `o fundo ${values.corporate_name} foi ${
          this.fund ? 'atualizado' : 'adicionado'
        }`
      );

      this.closeModal();
      this.fund = undefined;

      this.fundForm.reset();
    } catch (error) {
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao cadastrar o fundo de zeragem.'
      );
    }
  }

  async removeFund(id: number) {
    const { isConfirmed } = await Swal.fire({
      title: 'Tem certeza?',
      text: 'Você não poderá reverter isso!',
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Sim, apague!',
      showCancelButton: true,
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
    });

    if (isConfirmed) {
      this.api
        .delete({
          route: `api/registration/zeroing_fund/${id}/`,
          token: true,
        })
        .then((res) => {
          this.funds = this.funds.filter((fund) => fund.id !== id);

          Swal.fire({
            title: 'Apagado!',
            text: 'Fundo apagado com sucesso',
            icon: 'success',
            confirmButtonColor: '#3085d6',
          });
          this.getData();
        })
        .catch((error) => {
          Swal.fire({
            title: 'Erro!',
            text: 'Erro ao apagar fundo',
            icon: 'error',
            confirmButtonColor: '#3085d6',
          });
        });
    }
  }

  setData() {
    this.signupService.fillFormEvent.subscribe(() => {
      const companyName = fakerbr.company.companyName();

      this.fundForm.patchValue({
        document: this.maskPipe.transform(
          fakerbr.br.cnpj(),
          '00.000.000/0000-00'
        ),
        corporate_name: companyName,
        manager_name: fakerbr.name.findName(),
        manager_email: fakerbr.internet.email(),
        manager_ddi: '55',
        manager_phone: this.maskPipe.transform(
          '139' +
            String(fakerbr.random.number({ min: 11111111, max: 99999999 })),
          '(00) 00000-0000'
        ),
      });
    });
  }
}
